import { cn, Icon, type IconSize, type KyanIcon, Typography } from "@kyan/ui";

export interface WelcomeModalIconProps {
  name: KyanIcon;
  text?: string;
  bottom?: React.ReactNode;
  hideText?: boolean;
  iconSize?: IconSize;
  className?: string;
  iconClassName?: string;
  bgClassName?: string;
}

export const WelcomeModalIcon: React.FC<WelcomeModalIconProps> = ({
  name,
  text,
  bottom,
  hideText,
  iconSize = "lg",
  className,
  iconClassName,
  bgClassName,
}) => {
  return (
    <div className={cn("flex flex-col items-center gap-2.5", className)}>
      <div
        className={cn(
          "flex items-center justify-center rounded-sm bg-[url('/images/components/welcome-icon-bg.svg')] bg-contain bg-no-repeat",
          bgClassName,
        )}
      >
        <Icon
          size={iconSize}
          name={name as KyanIcon}
          className={cn("text-white", iconClassName)}
        />
      </div>
      {!hideText && (
        <div className="flex flex-col items-center gap-2">
          <Typography primary size={12}>
            {text ?? name.toUpperCase()}
          </Typography>
          {bottom}
        </div>
      )}
    </div>
  );
};
